import Utils from "../../../utility";

const initialState = {
  categoryList: [],
  count: 0,
  order: "DESC",
  sortField: "createdAt",
  offset: 1,
  take: 20,
  search: "",
};
export const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.CATEGORY}`:
      return {
        ...state,
        ...action.payload,
      };
    case `${Utils.ActionName.RESET_CATEGORY}`:
      return initialState;
    default:
      return { ...state };
  }
};
